import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { httpClient } from "../HttpClient";

export const getMasterTableData = createAsyncThunk("mastertable", async ({ page, limit, queryParams = "" }) => {
    try {
        const getAllData = await httpClient.get(`/internal-db/internal/db/asset_management/add-asset?paginate=true&page=${page}&limit=${limit}&${queryParams}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        const SignUpStatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getAllData", response);
        return {
            result,
            SignUpStatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }

}
);

export const getSAPData = createAsyncThunk("getSAPData", async ({ page, limit, queryParams = "" }) => {
    try {
        const getAllData = await httpClient.get(`/internal-db/internal/db/asset_management/add-sap_data?page=${page}&limit=${limit}&${queryParams}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        const SignUpStatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getAllData", response);
        return {
            result,
            SignUpStatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }

}
);
export const getITMSData = createAsyncThunk("getITMSData", async ({ page, limit, queryParams = "" }) => {
    try {
        const getAllData = await httpClient.get(`/internal-db/internal/db/asset_management/add-itms_data?page=${page}&limit=${limit}&${queryParams}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        const SignUpStatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getAllData", response);
        return {
            result,
            SignUpStatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }

}
);

export const getAssetDataById = createAsyncThunk("getAssetDataById", async (asset_id) => {
    try {
        const url = `/internal-db/internal/db/asset_management/add-asset?asset_id=${asset_id}`;
        console.log("Request URL:", url);  // Log the URL
        const getAllData = await httpClient.get(url, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        const SignUpStatusCode = getAllData.status;
        const result = response.Result;
        return {
            result,
            SignUpStatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
});

export const getGraphData = createAsyncThunk("getGraphData", async (queryParams = "") => {
    try {
        const getAllData = await httpClient.get(`internal-db/internal/db/asset_management/graph${queryParams}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
});

export const getAllDepartments = createAsyncThunk("getAllDepartments", async (queryParams = "") => {
    try {
        const getAllData = await httpClient.get(`/internal-db/internal/db/usermodels/department${queryParams}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getAllData", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }

}
);

export const addUser = createAsyncThunk("addUser", async (data) => {
    // /userapp/user
    try {
        const getAllData = await httpClient.post(`/internal-db/internal/db/usermodels/user`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all BD Reason", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const editUser = createAsyncThunk("editUser", async ({ data, user_id }) => {
    try {
        const getAllData = await httpClient.put(`/internal-db/internal/db/usermodels/user/${user_id}`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const deleteUser = createAsyncThunk("deleteUser", async (user_id) => {
    try {
        const getAllData = await httpClient.delete(`/internal-db/internal/db/usermodels/user/${user_id}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const getUserById = createAsyncThunk("getUserById", async (queryParams = "") => {
    try {
        const getAllData = await httpClient.get(`/internal-db/internal/db/usermodels/user${queryParams}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        const result = response.Result
        const StatusCode = getAllData.status;

        console.log("success in asset data", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }

}
);


export const UploadAssetMasterData = createAsyncThunk("UploadAssetMaster", async (data) => {
    try {
        const getAllData = await httpClient.post(`/internal-db/internal/db/asset_management/add-asset-master`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response;
        console.log("success in getting all BD Reason", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);


export const UploadVendorMasterData = createAsyncThunk("UploadVendorMasterData", async (data) => {
    try {
        const getAllData = await httpClient.post(`/internal-db/internal/db/asset_management/add-vendor_data`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response;
        console.log("success in getting all BD Reason", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const UploadSapDataAuto = createAsyncThunk("UploadSapDataAuto", async (queryParams = "") => {
    try {
        const getAllData = await httpClient.get(`/internal-db/internal/db/asset_management/auto-upload-sap_data${queryParams}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all BD Reason", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const UploadITMSFile = createAsyncThunk("UploadITMSFile", async (data) => {
    try {
        const getAllData = await httpClient.post(`/internal-db/internal/db/asset_management/itms_file_upload`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all BD Reason", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);


export const downloadAllMergedData = createAsyncThunk("downloadAllMergedData", async () => {
    try {
        const getAllData = await httpClient.get(`/internal-db/internal/db/asset_management/download-merged-data`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all BD Reason", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);


export const redisDeleteAll = createAsyncThunk("redisDeleteAll", async () => {
    try {
        const getAllData = await httpClient.get(`/internal-db/actuator/health/bootsrap?redisdeleteall=1`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all BD Reason", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);



const MastertableSlice = createSlice({
    name: "mastertable",
    initialState: {
        loading: false,
        error: null,
        response: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getMasterTableData.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(getMasterTableData.fulfilled, (state, action) => {
                state.loading = false;
                state.response = action.payload.result;
            })
            .addCase(getMasterTableData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
})

// export const { logout } = MastertableSlice.actions;
export default MastertableSlice.reducer;